import { render, staticRenderFns } from "./PopQuizExplanation.vue?vue&type=template&id=2021f8d2"
import script from "./PopQuizExplanation.vue?vue&type=script&lang=js"
export * from "./PopQuizExplanation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports